import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetOrderByIdQuery } from "@/features/api/orderApi";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export default function EditOrder() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: order, isLoading, error } = useGetOrderByIdQuery(id);

  if (isLoading) {
    return <p className="p-6 text-center text-lg">Loading order...</p>;
  }

  if (error) {
    return <p className="p-6 text-center text-red-500">Failed to fetch order</p>;
  }

  return (
    <div className="container mx-auto py-10 px-4 max-w-3xl">
      <Card className="shadow-lg rounded-2xl border">
        <CardHeader className="pb-4">
          <CardTitle className="text-2xl font-semibold">
            Edit Order{" "}
            <span className="text-muted-foreground">#{order?.id}</span>
          </CardTitle>
        </CardHeader>

        <Separator />

        <CardContent className="space-y-6 pt-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Detail label="Customer" value={order?.customerName} />
            <Detail label="Email" value={order?.email || "N/A"} />
            <Detail label="Phone" value={order?.phone || "N/A"} />
            <Detail label="Course" value={order?.productName} />
            <Detail label="Amount" value={`₹${order?.amount}`} />
            <Detail label="Status" value={order?.status} />
          </div>

          <Separator />

          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xl font-bold">
              Total Amount:{" "}
              <span className="text-primary">₹{order?.amount}</span>
            </p>
            <Button variant="outline" onClick={() => navigate(-1)}>
              Back
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}


function Detail({ label, value }) {
  return (
    <div className="p-3 bg-muted/40 rounded-xl border">
      <p className="text-sm text-muted-foreground">{label}</p>
      <p className="text-base font-medium">{value}</p>
    </div>
  );
}
